(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[640],{

/***/ 309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./pages/src/components/Footer/Footer.module.css
var Footer_module = __webpack_require__(6369);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./pages/src/assets/logo-bg-white.png
/* harmony default export */ var logo_bg_white = ({"src":"/_next/static/media/logo-bg-white.01ae7210.png","height":200,"width":460,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAIAAAAhqtkfAAAAVUlEQVR42mP49fv/9y/X//978/Xb7x8/fn7/8fPv339AwHD77rPJE/1/fFxx/eb9fQeOnzpz8dyFK2/evGMASt668/DHj29fvnx69/4NiHz35uvXLwCM0UD4MsgDxwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./pages/src/assets/iconsRedondosSocial/facebook.svg
/* harmony default export */ var facebook = ({"src":"/_next/static/media/facebook.3ea8cf92.svg","height":40,"width":40});
;// CONCATENATED MODULE: ./pages/src/assets/iconsRedondosSocial/instagram.svg
/* harmony default export */ var instagram = ({"src":"/_next/static/media/instagram.12a132fe.svg","height":40,"width":40});
;// CONCATENATED MODULE: ./pages/src/assets/iconsRedondosSocial/linkedin.svg
/* harmony default export */ var linkedin = ({"src":"/_next/static/media/linkedin.fad195f9.svg","height":40,"width":40});
;// CONCATENATED MODULE: ./pages/src/assets/iconsRedondosSocial/whatsapp.svg
/* harmony default export */ var whatsapp = ({"src":"/_next/static/media/whatsapp.051e25e3.svg","height":40,"width":40});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./pages/src/components/Footer/Footer.js










/*<div className={styles.links}>
            <h3>SITE LINKS</h3>
            <div className={styles.sectionLinks}>
            <div>
                <Link href="/">Home</Link>
                <Link href="/sustentabilidade">Sustentabilidade</Link>
                <Link href="/parceiros">Parceiros</Link>
              </div>
              <div>
                <Link href="/empresa">Empresa</Link>
                <Link href="/produtos-e-tecnologia">Produtos e Tecnologia</Link>
                <Link href="/contato">Contato</Link>
              </div>
            </div>
          </div>*/ var Footer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: (Footer_module_default()).footer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: " container-main",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Footer_module_default()).infos,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: (Footer_module_default()).logo,
                                    src: logo_bg_white,
                                    width: "460",
                                    height: "200",
                                    alt: "salinas-logo"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Footer_module_default()).contato,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "CONTATO"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "tel:+551432838344",
                                    children: "+55 14 3283-8344"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:comercial@salinasembalagem.com.br",
                                    children: "comercial@salinasembalagem.com.br"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (Footer_module_default()).contatoDetail
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Rua Benedito Bergamasco, O-35",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " Parque Industrial II Pederneiras - SP"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Footer_module_default()).informacoes,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "INFORMA\xc7\xd5ES"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/informacoes/certificacoes",
                                    children: "Certifica\xe7\xf5es"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/informacoes/politicas-e-valores",
                                    children: "Pol\xedticas e Valores"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/informacoes/responsabilidade-social",
                                    children: "Responsabilidade Social"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Footer_module_default()).links,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "DENUNCIA"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Footer_module_default()).sectionLinks,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "mailto:ouvidoria@salinasembalagem.com.br",
                                            children: "ouvidoria@salinasembalagem.com.br"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Footer_module_default()).subFooter,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Footer_module_default()).iconsGroup,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://pt-br.facebook.com/salinasembalagem/",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: "40",
                                        height: "40",
                                        src: facebook,
                                        alt: "facebook"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.instagram.com/salinasembalagem/",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: "40",
                                        height: "40",
                                        src: instagram,
                                        alt: "instagram"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.linkedin.com/in/salinas-embalagem-011768174/",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: "40",
                                        height: "40",
                                        src: linkedin,
                                        alt: "linkedin"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://api.whatsapp.com/send?phone=5514982180404",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: "40",
                                        height: "40",
                                        src: whatsapp,
                                        alt: "whatsapp"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (Footer_module_default()).copyRight,
                            children: "\xa9 2022 Cartonagem Salinas Fone: (+55) 14 3283-8344 – Benedito Bergamasco, O-35. Pederneiras – SP"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Footer_Footer = (Footer);


/***/ }),

/***/ 7331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header_Header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(603);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./pages/src/components/Header/Header.module.css
var Header_module = __webpack_require__(7370);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
;// CONCATENATED MODULE: ./pages/src/assets/logo.png
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.053664c5.png","height":1026,"width":2972,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAbUlEQVR4nGMsrUj3qMs/WMHF+TadWSCZ1cH/27e7b5kEHn9nuMXLwsDGqOmUf2NK6SN1e8tjk1kEEo5aen83//id8TsjA8MLBgaGv0C62Dc583vYnN5peXUdqTqcHP+4BPj+vP3xk4nj0xdmfgCXMyfA3XEFsAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./pages/src/assets/icons/facebook.svg
/* harmony default export */ var facebook = ({"src":"/_next/static/media/facebook.9c51623e.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./pages/src/assets/icons/instagram.svg
/* harmony default export */ var instagram = ({"src":"/_next/static/media/instagram.6937148d.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./pages/src/assets/icons/linkedin.svg
/* harmony default export */ var linkedin = ({"src":"/_next/static/media/linkedin.d0633ae1.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./pages/src/assets/icons/whatsapp.svg
/* harmony default export */ var whatsapp = ({"src":"/_next/static/media/whatsapp.78de619a.svg","height":16,"width":16});
// EXTERNAL MODULE: ./pages/src/hooks/useMedia.js
var useMedia = __webpack_require__(2495);
;// CONCATENATED MODULE: ./pages/src/assets/header/close.svg
/* harmony default export */ var header_close = ({"src":"/_next/static/media/close.51d16493.svg","height":40,"width":40});
;// CONCATENATED MODULE: ./pages/src/assets/header/menu2.svg
/* harmony default export */ var menu2 = ({"src":"/_next/static/media/menu2.62a8c004.svg","height":495,"width":495});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./pages/src/components/Header/Header.js















var Header = function() {
    var mobile = (0,useMedia["default"])("(max-width: 40rem)");
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), mobileMenu = ref[0], setMobileMenu = ref[1];
    var pathname = (0,router.useRouter)().pathname;
    react.useEffect(function() {
        if (mobileMenu) {
            window.scrollTo(0, 0);
        }
    }, [
        mobileMenu
    ]);
    react.useEffect(function() {
        if (mobile) {
            var closeMenu = function closeMenu(param) {
                var target = param.target;
                if (target.href === window.location.href) {
                    setMobileMenu(false);
                }
            };
            var links = document.querySelectorAll("[data-menu] li a");
            links.forEach(function(link) {
                link.addEventListener("click", closeMenu);
            // link.addEventListener('touchstart', closeMenu);
            });
        }
    });
    react.useEffect(function() {
        setMobileMenu(false);
        window.scrollTo(0, 0);
    }, [
        pathname
    ]);
    if (mobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: (Header_module_default()).header,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: " container-main",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: (Header_module_default()).logo,
                                    src: logo,
                                    alt: "salinas-logo"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            "aria-label": "Menu",
                            className: "".concat((Header_module_default()).mobileButton, " ").concat(mobileMenu && (Header_module_default()).mobileButtonActive),
                            onClick: function() {
                                return setMobileMenu(!mobileMenu);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: menu2,
                                alt: "menu-hamburger",
                                height: 30,
                                width: 30
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                    className: (Header_module_default()).navHeader,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        "data-menu": true,
                        className: "".concat((Header_module_default()).mobileMenu, " ").concat(mobileMenu && (Header_module_default()).mobileMenuActive, " \n"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return setMobileMenu(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: header_close,
                                    alt: "close",
                                    height: 30,
                                    width: 30
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: "Home"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/empresa",
                                    children: "Empresa"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/sustentabilidade",
                                    children: "Sustentabilidade"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/produtos-e-tecnologia",
                                    children: "Produtos e Tecnologia"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/parceiros",
                                    children: "Parceiros"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/contato",
                                    children: "Contato"
                                })
                            })
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (Header_module_default()).header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: " container-main",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: (Header_module_default()).logo,
                                width: 2000,
                                height: 680,
                                src: logo,
                                alt: "salinas-logo"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (Header_module_default()).listIcons,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://pt-br.facebook.com/salinasembalagem/",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: (Header_module_default()).iconsSocial,
                                        height: 30,
                                        width: 30,
                                        alt: "facebook-logo",
                                        src: facebook
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.instagram.com/salinasembalagem/",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: (Header_module_default()).iconsSocial,
                                        height: 30,
                                        width: 30,
                                        alt: "instagram-logo",
                                        src: instagram
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://www.linkedin.com/in/salinas-embalagem-011768174/",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        alt: "linkedin-logo",
                                        className: (Header_module_default()).iconsSocial,
                                        height: 30,
                                        width: 30,
                                        src: linkedin
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://api.whatsapp.com/send?phone=5514982180404",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: (Header_module_default()).iconsSocial,
                                        height: 30,
                                        alt: "whatsapp-logo",
                                        width: 30,
                                        src: whatsapp
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: (Header_module_default()).navHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "".concat((Header_module_default()).navgation, "  container-main"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: "Home"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/empresa",
                                children: "Empresa"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/sustentabilidade",
                                children: "Sustentabilidade"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/produtos-e-tecnologia",
                                children: "Produtos e Tecnologia"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/parceiros",
                                children: "Parceiros"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/contato",
                                children: "Contato"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Header_Header = (Header);


/***/ }),

/***/ 2495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(603);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


var useMedia = function(media) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(null), 2), match = ref[0], setMatch = ref[1];
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        var changeMatch = function changeMatch() {
            var matches = window.matchMedia(media).matches;
            setMatch(matches);
        };
        changeMatch();
        window.addEventListener("resize", changeMatch);
        return function() {
            return window.removeEventListener("resize", changeMatch);
        };
    }, [
        media
    ]);
    return match;
};
/* harmony default export */ __webpack_exports__["default"] = (useMedia);


/***/ }),

/***/ 6369:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__iPOLS","logo":"Footer_logo___22TB","infos":"Footer_infos__2wOEP","contatoDetail":"Footer_contatoDetail__8CpYK","sectionLinks":"Footer_sectionLinks__47rCH","subFooter":"Footer_subFooter___zUXB","iconsGroup":"Footer_iconsGroup__iBhXC","copyRight":"Footer_copyRight__a23xg"};

/***/ }),

/***/ 7370:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__QOOkQ","navHeader":"Header_navHeader__k5cHr","logo":"Header_logo__6Ftmk","listIcons":"Header_listIcons__Be25_","iconsSocial":"Header_iconsSocial__OJdOe","navgation":"Header_navgation__pMPBa","mobileButton":"Header_mobileButton__jJF2q","mobileMenu":"Header_mobileMenu__l8WcC","mobileMenuActive":"Header_mobileMenuActive__hcR1J"};

/***/ })

}]);